
angular.module('bmsApp.crm.customer').factory('SiteSvc', [
	'$q',
	'$rootScope',
	'$modal',
	'$ngBootbox',
	'notify',
	'CRUDSvc',
	'SITE_API', function (
		$q,
		$rootScope,
		$modal,
		$ngBootbox,
		notify,
		CRUDSvc,
		SITE_API) {

		var self = {
			create: function (site) {
				return CRUDSvc.post(SITE_API.CREATE, site);
			},
			update: function (site) {
				return CRUDSvc.post(SITE_API.UPDATE + site.id, site);
			},
			save: function (site) {
				return CRUDSvc.post(SITE_API.SAVE, site);
			},
			setPrimary: function (site) {
				return CRUDSvc.get(SITE_API.SET_PRIMARY + site.id);
			},
			byCustomer: function (customerId, primary, params) {
				var newParams = angular.extend({}, params, {
					filter: {
						customer: customerId
					}
				});
				if (angular.isDefined(primary)) {
					angular.extend(newParams.filter, {
						primary: primary
					});
				}
				return CRUDSvc.get(SITE_API.INDEX, newParams);
			},
			customerOptions: function (customerId, params) {
				var newParams = angular.extend({}, params, {
					filter: {
						customer: customerId
					}
				});
				return CRUDSvc.get(SITE_API.OPTIONS, newParams);
			},
			showSaveModal: function (site) {
				var modalInstance = $modal.open({
					animation: true,
					templateUrl: 'ng/crm/customer/templates/SiteSaveModal.html',
					controller: 'SiteModalFormCtrl',
					size: 'lg',
					scope: $rootScope,
					backdrop: 'static', // disable click-outside closing modal
					resolve: {
						site: function () {
							return angular.copy(site);
						}
					}
				});

				modalInstance.result.then(function (result) {
					if (result.success === true) {
						var message;
						switch (result.action) {
							case 'create':
								message = 'Site created successfully';
								break;
							case 'update':
								message = 'Site updated successfully';
								break;
							default:
								message = 'Success';
								break;
						}
						notify({
							message: message
						});
					}
					else {
						notify({
							mesage: result.error,
							classes: 'error'
						});
					}
				}, function () {
					// closed
				});

				return modalInstance.result;
			},
			lookup: function(params) {
				return CRUDSvc.get(SITE_API.LOOKUP, params);
			}
		};
		return self;

}]).constant('SITE_API', {
	INDEX: 'api/site/index',
	CREATE: 'api/site/create',
	UPDATE: 'api/site/update/',
	SAVE: 'api/site/save',
	OPTIONS: 'api/site/options',
	SET_PRIMARY: 'api/site/set-primary/',
	LOOKUP: 'api/site/address/lookup',
});
